// export default Footer;
import React, { useState } from 'react';
import { facebook, instagram, twitter, linkedin, inputbtn, youtube } from "./import";
import './footer.css';


const Footer = () => {
    // Define data for footer links
    const footerLinks = [
        {
            title: "ABOUT US",
            links: [
                { label: "Our Values", url: "/404" },
                { label: "Our Leadership", url: "/about#leadership" },
                { label: "Our Partners", url: "/#key-implimenting-parter" },
                { label: "Reports", url: "/annual-reports" },
                { label: "Financials", url: "/finance" }
            ]
        },
        {
            title: "WHAT WE DO",
            links: [
                { label: "Healthcare", url: "/healthcare" },
                { label: "Education", url: "/education" },
                { label: "Livelihood", url: "/404" },
                // { label: "Other SDGs", url: "/#sdgsec" },
            ]
        },
        {
            title: "NEWSROOM",
            links: [
                { label: "Videos", url: "https://www.youtube.com/@ECHOIndia/videos" },
                // { label: "Press Releases", url: "#" },
                { label: "Insights and Stories", url: "blogs" }
            ]
        },
        {
            title: "IMPACT",
            links: [
                { label: "Impact and Outreach", url: "https://drive.google.com/file/d/1qgUtCkO5Lkz5-UK_hK-cqooNLyrKMtab/view?usp=drive_link" }
            ]
        },
        {
            title: "JOIN OUR TEAM",
            links: [
                { label: "Partner with us", url: "/partner" },
                { label: "Start an ECHO", url: "/training" },
                { label: "Careers", url: "/careers" }
            ]
        }
    ];

    const [email, setEmail] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        const MAILCHIMP_URL = 'https://us15.api.mailchimp.com/3.0/lists/b04b2bd268/members/';
        const MAILCHIMP_API_KEY = 'cd5810d4a2ceba8f4e6fcb8298f9da5a-us15';

        try {
            const response = await fetch(MAILCHIMP_URL, {
                method: 'POST',
                headers: {
                    'Authorization': `apikey  ${MAILCHIMP_API_KEY}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email_address: email,
                    status: 'subscribed'
                })
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
            }

            alert('Thank you for subscribing!');
            setEmail('');
        } catch (error) {
            console.error('Error:', error);
            alert(`An error occurred: ${error.message}`);
        }
    };

    return (
        <section className="footer">
            <div className="footer-container">
                <div className="row">
                    <div className="col-12">
                        <ul className="footer-main">
                            {/* Email Newsletter Signup */}
                            {/* <li>
                                <h1 className="text-uppercase">Email Newsletter Signup</h1>
                                <div className="newsletter">
                                    <div className="inputEmail">
                                        <form onSubmit={handleSubmit}>
                                            <input type="email" placeholder="Your Email"
                                                required
                                                onChange={e => {
                                                    setEmail(e.target.value);
                                                }}
                                            />
                                        </form>
                                    </div>
                                    <div className="iconemail">
                                        <img src={inputbtn} className="img-fluid" alt="img" />
                                    </div>
                                </div>
                                <h3 className="text-uppercase">Connect With Us</h3>
                                <div className="connect">
                                    <div className="fb">
                                        <a target="blank" href="https://www.facebook.com/ECHOIndiaTrust">
                                            <img src={facebook} alt="facebook Echo india" className="img-fluid" />
                                        </a>
                                    </div>
                                    <div className="twitter">
                                        <a target="blank" href="https://twitter.com/ECHOIndiaTrust">
                                            <img src={twitter} alt="twitter Echo india" className="img-fluid" />
                                        </a>
                                    </div>
                                    <div className="Linkedin">
                                        <a target="blank" href="https://www.linkedin.com/company/echoindia/">
                                            <img src={linkedin} alt="linkedin Echo india" className="img-fluid" />
                                        </a>
                                    </div>
                                    <div className="insta">
                                        <a target="blank" href="https://www.instagram.com/echoindia1/">
                                            <img src={instagram} alt="instagram Echo india" className="img-fluid" />
                                        </a>
                                    </div>
                                    <div className="insta">
                                        <a target="blank" href="https://www.youtube.com/channel/UCrlqLJYrX5BA1MRcB0LbGAg">
                                            <img src={youtube} alt="youtube Echo india" className="img-fluid" />
                                        </a>
                                    </div>
                                </div>
                            </li> */}
                            {/* Render footer links */}
                            {footerLinks.map((footerItem, index) => (
                                <li key={index}>
                                    <ul className={`footer-${index}`}>
                                        <h1>{footerItem.title}</h1>
                                        {footerItem.links.map((link, idx) => (
                                            <li key={idx}>
                                                <a href={link.url}>{link.label}</a>
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Footer;


